import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import album from '@/static/album.json'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    loader: 0,
    loaderText: 'loader_text',
    currAlbumPage: null,
    markers: [
      {
        level: 'EG',
        id: 'EG_SF_04',
        top: 25.5,
        left: 89.1,
        label1908: 'Skulpturenhalle X'
      },
      {
        level: 'OG-1',
        id: 'OG-1_SF_05',
        top: 24.5,
        left: 91.3,
        label1908: 'Gobelinsaal IX'
      },
      {
        level: 'OG-1',
        id: 'OG-1_SF_04',
        top: 40,
        left: 91.3,
        label1908: 'Zimmer VIII'
      },
      {
        level: 'OG-1',
        id: 'OG-1_SF_03',
        top: 50.2,
        left: 91.3,
        label1908: 'Zimmer VII'
      },
      {
        level: 'OG-1',
        id: 'OG-1_SF_02',
        top: 61.6,
        left: 91.3,
        label1908: 'Zimmer VI'
      },
      {
        level: 'OG-1',
        id: 'OG-1_VH_01',
        top: 90,
        left: 91.3,
        label1908: 'Musiksaal V'
      },
      {
        level: 'OG-1',
        id: 'OG-1_VH_02',
        top: 90,
        left: 64.3,
        label1908: 'Rokkoko-Zimmer VII'
      },
      {
        level: 'OG-1',
        id: 'OG-1_VH_03',
        top: 90,
        left: 49.9,
        label1908: 'Herren-Zimmer VIII'
      },
      {
        level: 'OG-1',
        id: 'OG-1_VH_04',
        top: 90,
        left: 33.9,
        label1908: 'Damen-Zimmer IX'
      },
      {
        level: 'OG-1',
        id: 'OG-1_VH_05',
        top: 90,
        left: 13.8,
        label1908: 'Speise-Zimmer X'
      },
      {
        level: 'OG-2',
        id: 'OG-2_VH_01',
        top: 87.7,
        left: 88.8,
        label1908: 'Festsaal XV'
      },
      {
        level: 'OG-2',
        id: 'OG-2_VH_02',
        top: 89.0,
        left: 63.8,
        label1908: 'Zimmer XVII'
      },
      {
        level: 'OG-2',
        id: 'OG-2_VH_03',
        top: 89.0,
        left: 49.4,
        label1908: 'Zimmer XVIII'
      },
      {
        level: 'OG-2',
        id: 'OG-2_VH_04',
        top: 89.0,
        left: 34.5,
        label1908: 'Zimmer XIX'
      },
      {
        level: 'OG-2',
        id: 'OG-2_VH_05',
        top: 89.0,
        left: 16.8,
        label1908: 'Zimmer XX'
      },
      {
        level: 'OG-2',
        id: 'OG-2_SF_01',
        top: 74.7,
        left: 88.8,
        label1908: 'Vorraum XI'
      },
      {
        level: 'OG-2',
        id: 'OG-2_SF_02',
        top: 61.4,
        left: 88.8,
        label1908: 'Zimmer XII'
      },
      {
        level: 'OG-2',
        id: 'OG-2_SF_03',
        top: 51.6,
        left: 88.8,
        label1908: 'Zimmer XIII'
      },
      {
        level: 'OG-2',
        id: 'OG-2_SF_04',
        top: 42.4,
        left: 88.8,
        label1908: 'Zimmer XIV'
      },
      {
        level: 'OG-2',
        id: 'OG-2_HF_01',
        top: 76.1,
        left: 74.7,
        label1908: 'Nebenraum XVI'
      }
    ],
    lang: 'de',
    translate: {
      'Abschnitt': {
        en: 'Section',
        de: 'Abschnitt'
      },
      'Einleitung': {
        en: 'Introduction',
        de: 'Einleitung'
      },
      'Beitrag': {
        en: 'Post',
        de: 'Beitrag'
      },
      'Aktuelles': {
        en: 'News',
        de: 'Aktuelles'
      },
      'Beiträge': {
        en: 'Posts',
        de: 'Beiträge'
      },
      'no_posts_in_category_and_language': {
        en: 'No posts found in this category and language',
        de: 'Keine Beiträge in dieser Kategorie und Sprache gefunden'
      },
      'mehr_erfahren': {
        en: 'learn more',
        de: 'mehr erfahren'
      },
      'search_results': {
        en: 'Searchresults',
        de: 'Suchergebnisse'
      },
      'Basisrecherche (Hausarbeit) von': {
        en: 'Term paper',
        de: 'Seminararbeit'
      },
      'Danksagung': {
        en: 'Acknowledgments',
        de: 'Unterstützung und Auskünfte'
      },
      'Textquelle': {
        en: 'Textual Source',
        de: 'Textquelle'
      },
      'Bilddokument': {
        en: 'Image document',
        de: 'Bilddokument'
      },
      'num_search_results': {
        en: 'objects found',
        de: 'Objekte gefunden'
      },
      'db_object_not_found': {
        en: 'The requested object could not be found in the database.',
        de: 'Das angefragte Objekt konnte in der Datenbannk nicht gefunden werden.'
      },
      'loading': {
        en: 'loading',
        de: 'Lade'
      },
      'loading_db': {
        en: 'loading database',
        de: 'Lade Datenbank'
      },
      'DB-Abdeckung': {
        en: '<p>The MARI database is in a process of continuous expansion: it currently only includes subsets of the works that were part of the Mosse/Lachmann-Mosse collection. Please also consult the <a   href="http://www.lostart.de/Webs/DE/LostArt/Index.html" alt="Link zu Lost Art-Datenbank des Deutschen Zentrums   Kulturgutverluste" target="_blank">Lost Art Internet Database</a>, Deutsches Zentrum Kulturgutverluste</p>',
        de: '<p>Die MARI-Datenbank befindet sich im Aufbau. Sie erfasst zurzeit nur einen Teil der Werke, die sich in der Sammlung Mosse bzw. Lachmann-Mosse befanden.<br/>Bitte konsultieren Sie auch die <a   href="http://www.lostart.de/Webs/DE/LostArt/Index.html" alt="Link zu Lost Art-Datenbank des Deutschen Zentrums   Kulturgutverluste" target="_blank">Lost Art-Datenbank</a> des Deutschen Zentrums Kulturgutverluste.</p>'
      },
      'Werke': {
        en: 'Artworks',
        de: 'Werke'
      },
      'Suchen': {
        en: 'Search',
        de: 'Suchen'
      },
      'Suche': {
        en: 'Search',
        de: 'Suche'
      },
      'Alle Werke': {
        en: 'All Works',
        de: 'Alle Werke'
      },
      'Künstler': {
        en: 'Artists',
        de: 'Künstler'
      },
      'mehr': {
        en: 'Metadata from Sources',
        de: 'Metadaten aus den Quellen'
      },
      'beziehungen_zu_diesem_werk': {
        en: 'Sources',
        de: 'Quellen'
      },
      'beziehungstyp': {
        en: 'Relation Type',
        de: 'Art der Beziehung'
      },
      'lost_art_link': {
        en: 'Lost Art Link',
        de: 'Lost Art Link'
      },
      'Forschungsstand': {
        en: 'State of Research',
        de: 'Forschungsstand'
      },
      // // // // Metadaten des Objekttyps Publikation
      'Ausgabe-Format': {
        en: 'Source',
        de: 'Quelle'
        // Anzeige in Textnachricht etc. anstelle von Feld Quellenangabe (ausschließendes oder)
      },
      // // // // Metadaten des Objekttyps Nachricht Textquelle
      // // // Quellenangaben
      'Quellenangabe': {
        en: 'Source',
        de: 'Quelle'
      },
      'Angabe Online-Quelle, Bezeichnung': {
        en: 'Source',
        de: 'Quelle'
        // als Link mit der URL aus Angabe Online-Quelle, URL
      },
      'Seite in Quelle': {
        en: 'Pagenumber',
        de: 'Seitenangabe'
      },
      'Nr. in Quelle': {
        en: 'Number',
        de: 'Nummer'
      },
      'Verweis Abbildung': {
        en: 'Illustration reference',
        de: 'Abbildungsverweis'
      },
      'Keine Abbildung vorhanden': {
        en: 'No image available',
        de: 'Keine Abbildung vorhanden'
      },
      // // // Metadaten zum Werk (Shared Object)
      'Objekt-Kategorie': {
        // ohne Feldbezeichnung ausgeben
        en: '',
        de: ''
      },
      // // Basisdaten
      'Titel': {
        en: 'Title',
        de: 'Titel'
      },
      'Urheber': {
        en: 'Artist',
        de: 'Künstler'
      },
      'Material und Technik': {
        en: 'Material and Technique',
        de: 'Material und Technik'
      },
      'Maße': {
        en: 'Dimensions',
        de: 'Maße'
      },
      // // charakterisierende Metadaten
      'Beschreibung': {
        en: 'Description',
        de: 'Beschreibung'
      },
      'Information Zustand, Beschaffenheit': {
        en: 'Condition',
        de: 'Zustand'
      },
      'Rubrik': {
        en: 'Category',
        de: 'Rubrik'
      },
      // // Details zum Objekt
      'Rahmen': {
        en: 'Frame',
        de: 'Angaben zur Rahmung'
      },
      'Signatur': {
        en: 'Signature or writing on the work',
        de: 'Bezeichnung'
      },
      'Datierung': {
        en: 'Date',
        de: 'Angaben zur Datierung'
      },
      'Erwerbung durch Mosse': {
        en: 'Information on Mosse\'s acquisition of the work',
        de: 'zum Erwerb durch Mosse'
      },
      'Angabe Besitzer/Eigentümer': {
        en: 'Owner',
        de: 'Besitzer'
      },
      'Angabe Vorbesitzer': {
        en: 'Previous owner',
        de: 'früherer Besitzer'
      },
      'Angabe Transaktion': {
        en: 'Transaction',
        de: 'Transaktion'
      },
      'Preisangaben': {
        en: 'Price Information',
        de: 'Preisangabe'
      },
      'Angabe Ausstellung': {
        en: 'Exhibition references',
        de: ''
      },
      'Ort': {
        en: 'Location',
        de: 'Ort'
      },
      'Angabe Standort': {
        en: 'Information about the location',
        de: 'Angabe zum Standort'
      },
      'Nachricht über das Werk': {
        en: 'History of the object',
        de: 'Geschichte des Werkes'
      },
      'Bildlegende': {
        en: 'Imagecaption',
        de: 'Bildlegende'
      },
      'Bildrechte': {
        en: 'Image rights',
        de: 'Bildrechte'
      },
      'Online-Quelle': {
        en: 'Online-Resource',
        de: 'Online-Quelle'
      },
      // // ergänzende Informationen
      'Verweis Literatur': {
        en: 'References',
        de: 'Literaturhinweise'
      },
      // // // Anmerkungen
      'Referenz': {
        en: 'Notes',
        de: 'Anmerkungen'
      },
      // // // // in shared objects
      'Claim vor MARI': {
        en: 'located before MARI',
        de: 'lokalisiert vor MARI'
      },
      // // // filter
      'Anzeigen alle Objekte': {
        en: 'Show objects',
        de: 'Anzeigen Objekte'
      },
      'nur Buchobjekte': {
        en: 'Only Books',
        de: 'Nur Buchobjekte'
      },
      'von MARI bearbeitet': {
        en: 'researched by MARI',
        de: 'von MARI bearbeitet'
      },
      'von MARI lokalisiert': {
        en: 'localized by MARI',
        de: 'von MARI lokalisiert'
      },
      'lokalisiert vor MARI': {
        en: 'located before MARI',
        de: 'lokalisiert vor MARI'
      },
      'alle': {
        en: 'all',
        de: 'alle'
      },
      'Nachgewiesen in': {
        en: 'Documented in',
        de: 'Nachgewiesen in'
      },
      'alle Quellen': {
        en: 'all sources',
        de: 'alle Quellen'
      },
      'andere Quellen': {
        en: 'other sources',
        de: 'andere Quellen'
      },
      'Detailseite': {
        en: 'Details about this object ...',
        de: 'Details zu diesem Objekt ...'
      },
      'transactions': {
        en: 'Provenance',
        de: 'Provenienz'
      },
      'allgemeine Quelle': {
        en: 'Resource',
        de: 'Quelle'
      },
      'Seite zurück': {
        en: 'go back',
        de: 'zurück'
      },
      'Bildquellen': {
        en: 'Image Sources',
        de: 'Bildquellen'
      },
      Forschungsdatenbank: {
        en: 'Research Database',
        de: 'Forschungsdatenbank'
      },
      Zitierhinweis: {
        en: 'Please cite this entry as:',
        de: 'Bitte zitieren Sie den Eintrag zu diesem Werk als:'
      },
      Volltextsuche: {
        en: 'Fulltext Search',
        de: 'Volltextsuche'
      },
      'Erweiterte Suche': {
        en: 'Advanced Search',
        de: 'Erweiterte Suche'
      },
      'Weitere Angaben': {
        de: 'Weitere Angaben',
        en: 'Details'
      },
      // Album
      'Intro Album': {
        de: 'Album Amicorum',
        en: 'Album Amicorum'
      },
      'Sub Album': {
        de: 'für Rudolf Mosse zum 8. Mai 1913',
        en: 'dedicated to Rudolf Mosse, May 8th, 1913'
      },
      'Widmungen': {
        de: 'Widmungen von:<br>(Namen anklicken)',
        en: 'Dedications by:<br>(click on names)'
      },
      'Widmung von': {
        de: 'Widmung von',
        en: 'Dedication by'
      },
      'Titelseite Album': {
        de: '(Titelseite)',
        en: '(Title Page)'
      },
      // Pläne
      'Intro Pläne': {
        de: 'Sammlungspräsentation im Mosse-Palais, Leipziger Platz',
        en: 'Presentation of the Mosses Collection in Mosse-Palais, Leipziger Platz'
      },
      'Zur Anzeige der Werke bitte im Plan auf einen Raum klicken!': {
        de: 'Zur Anzeige der Werke bitte im Plan auf einen Raum klicken!',
        en: 'Click on a room in the plan to display list of works'
      },
      'Werke in Raum': {
        de: 'Werke in Raum',
        en: 'works in room'
      },
      'Zeitstufe': {
        de: 'Zeitstufe',
        en: 'Period'
      },
      // Geschossangaben
      'Geschoss': {
        de: 'Geschoss',
        en: 'Floor'
      },
      'EG': {
        de: 'Erdgeschoss',
        en: 'Ground Floor'
      },
      'OG1': {
        de: '1. OG',
        en: 'First Floor'
      },
      'OG2': {
        de: '2. OG',
        en: 'Second Floor'
      },
      'Quelle der Rekonstruktion': {
        de: 'Quelle der Rekonstruktion',
        en: 'Source of reconstruction'
      },
      'Katalog einsehen': {
        de: 'Katalog einsehen ...',
        en: 'Show catalog ...'
      },
      'page_not_found': {
        de: '404 - Seite nicht gefunden',
        en: '404 - Page not found'
      },
      'page_not_found_text': {
        de: 'Die angeforderte Seite konnte nicht gefunden werden.',
        en: 'The requested page could not be found.'
      },
      'loader_text': {
        de: 'Die Anwendung wird geladen ...',
        en: 'Loading application ...'
      },
      'loader_text_db': {
        de: 'Die Werkliste wird geladen ...',
        en: 'Loading list of works ...'
      },
      'loader_text_mosse_palais': {
        de: 'Auf der Grundlage von historischen Plänen wurde ein interaktiver Grundriss des Mosse-Palais\' am Leipziger Platz erstellt und die in den Sammlungskatalogen verzeichneten Standorte der Kunstwerke den Räumen zugeordnet ...',
        en: 'An interactive floor plan of the Mosse-Palais on Leipziger Platz was created on the basis of historical plans and the locations of the artworks listed in the collection catalogs were assigned to the rooms ...'
      },
      '404': {
        de: '404 - Objekt nicht gefunden. Bitte überprüfen Sie die URL. Fehlermeldung war:',
        en: '404 - Object not found. Please check the URL. Error message was:'
      },
      'ohne Autorenangabe': {
        de: 'ohne Autorenangabe',
        en: 'without author'
      },
      'Bibliotheksobjekte': {
        de: 'Bibliotheksobjekte',
        en: 'Library objects'
      },
      'Kunstwerke': {
        de: 'Kunstwerke',
        en: 'Artworks'
      },
      'Genealogie der Familie Lachmann': {
        de: 'Genealogie der Familie Lachmann',
        en: 'Genealogy of the Lachmann Family'
      },
      'Geburtsname': {
        de: 'Geburtsname',
        en: 'Birth name'
      },
      'Lebensdaten': {
        de: 'Lebensdaten',
        en: 'Life dates'
      },
      'Biografische Informationen': {
        de: 'Biografische Informationen',
        en: 'Biographical Information'
      },
      'genealogie-hint': {
        de: 'Klicken Sie auf eine Person im Stammbaum, um mehr Informationen zu erhalten.',
        en: 'Click on a person in the family tree to get more information.'
      },
      'maintenance': {
        de: 'Dieser Seitenbereich befindet sich derzeit im Wartungsmodus. Bitte versuchen Sie es später erneut.',
        en: 'This page area is currently under maintenance. Please check back later.'
      },
      'maintenance_title': {
        de: 'Wartungs&shy;arbeiten',
        en: 'Maintenance'
      }
    },
    pages: [],
    posts: [],
    aktuelles: [],
    firstpost: {},
    pagesMultilang: { 'de': [], 'en': [] },
    pageNav: [],
    pageNavMultilang: { 'de': [], 'en': [] },
    dbIndex: [],
    contextTransactions: [
      {
        'Datum Transaktion (maschinell)': '1920-09-08',
        'Datum Transaktion Ausgabe': '08.09.1920',
        'Vorbesitzer': 'Rudolf Mosse',
        'Erwerber': 'Emilie Mosse',
        'Transaktion Ausgabe': '[Kontext:]<br>Eigentumsübertragung<br>Rudolf Mosse (†&nbsp;08.09.1920) an<br>Emilie Mosse als Alleinerbin',
        'Kontext': true
      },
      {
        'Datum Transaktion (maschinell)': '1924-10-12',
        'Datum Transaktion Ausgabe': '12.10.1924',
        'Vorbesitzer': 'Emilie Mosse',
        'Erwerber': 'Felicia Lachmann-Mosse',
        'Transaktion Ausgabe': '[Kontext:]<br>Eigentumsübertragung<br>Emilie Mosse (†&nbsp;12.10.1924) an<br>Felicia Lachmann-Mosse als Alleinerbin',
        'Kontext': true
      },
      {
        'Datum Transaktion (maschinell)': '1934-02-05',
        'Datum Transaktion Ausgabe': '05.02.1934',
        'Vorbesitzer': 'Felicia Lachmann-Mosse',
        'Erwerber': 'Rudolf Mosse Treuhand Verwaltungs GmbH',
        'Transaktion Ausgabe': '[Kontext:]<br>Eigentumsübertragung<br>Felicia Lachmann-Mosse an<br>Rudolf Mosse Treuhand Verwaltungs GmbH',
        'Kontext': true
      }
    ],
    rooms: [
      {
        sigle: 'EG_SF_04',
        position: {
          x: 34.56,
          y: 12.78
        },
        1900: 'Skulpturenhalle',
        1908: 'Skulpturenhalle X',
        1912: 'Skulpturensaal IV',
        1913: 'Skulpturensaal IV',
        1915: 'Skulpturensaal IV',
        1921: 'Skulpturensaal IV'
      },
      {
        sigle: 'EG_SF_05',
        position: {
          x: 44.56,
          y: 42.78
        },
        1900: null,
        1908: null,
        1912: 'Kuppelraum V',
        1913: 'Kuppelraum V',
        1915: 'Kuppelraum V',
        1921: 'Kuppelraum V'
      },
      {
        sigle: 'EG_HF_01',
        position: {
          x: 54.56,
          y: 52.78
        },
        1900: null,
        1908: null,
        1912: 'Loggia VI',
        1913: 'Loggia VI',
        1915: 'Loggia VI',
        1921: 'Loggia VI'
      }
    ],
    plans: {
      1908: [
        {
          EG: '/static/img/plans/1908_EG_01.svg',
          OG1: '/static/img/plans/1908_OG_01_01.svg',
          OG2: '/static/img/plans/1908_OG_02_01.svg'
        }
      ]
    },
    periods: [1908, 1915, 1921],
    roomPeriods: [
      {
        year: 1908,
        source: 'Mosse 1908',
        key: 'period1908',
        levels: ['EG', 'OG1', 'OG2'],
        thumb: 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K_1908_Cover_thumbnail.jpg',
        pdf: 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K08_KBB_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1908-Leo-Baeck.pdf'

      },
      {
        year: 1915,
        source: 'Mosse 1915',
        key: 'period1915'
      },
      {
        year: 1921,
        source: 'Mosse 1921',
        key: 'period1921'
      }
    ],
    roomIds: [
      'EG_VH_01',
      'EG_VH_02',
      'EG_SF_01',
      'EG_SF_02',
      // 'EG_SF_03',
      'EG_SF_04',
      'EG_SF_05',
      'EG_HF_01',
      'OG-1_VH_01',
      'OG-1_VH_02',
      'OG-1_VH_03',
      'OG-1_VH_04',
      'OG-1_VH_05',
      'OG-1_SF_01',
      'OG-1_SF_02',
      'OG-1_SF_03',
      'OG-1_SF_04',
      'OG-1_SF_05',
      // 'OG-1_SF_06',
      'OG-1_HF_01',
      // 'OG-1_HF_02',
      // 'OG-1_HF_03',
      'OG-2_VH_01',
      'OG-2_VH_02',
      'OG-2_VH_03',
      'OG-2_VH_04',
      'OG-2_VH_05',
      'OG-2_SF_01',
      'OG-2_SF_02',
      'OG-2_SF_03',
      'OG-2_SF_04',
      'OG-2_HF_01',
      'OG-2_HF_02'
      // 'OG-2_HF_03'
    ],
    roomListings: {},
    sharedObjects: [],
    sharedObject: {},
    sharedObjectLoader: 0,
    metaSources: {},
    archivbestandObjekts: [],
    displayFields: ['Titel', 'Urheber', 'Material und Technik', 'Maße', 'Beschreibung', 'Information Zustand, Beschaffenheit', 'Rubrik', 'Rahmen', 'Signatur', 'Datierung', 'Erwerbung durch Mosse', 'Angabe Besitzer/Eigentümer', 'Angabe Vorbesitzer', 'Angabe Transaktion', 'Preisangaben', 'Angabe Ausstellung', 'Ort', 'Angabe Standort', 'Nachricht über das Werk', 'Weitere Angaben', 'Verweis Literatur', 'Referenz'],
    postCategories: [],
    genealogyPersons: [],
    errors: []
  },
  getters: {
    loader: state => state.loader,
    loaderText: state => state.loaderText,
    currAlbumPage (state) {
      return state.currAlbumPage
    },
    album () {
      return album
    },
    markers1908 (state) {
      const period = '1908'
      const markers = state.markers.map(m => {
        const marker = m
        marker.label = m[`label${period}`]
        return marker
      })
      let eg = markers
      .filter(m => m.level === 'EG')
      let og1 = markers
      .filter(m => m.level === 'OG-1')
      let og2 = markers
      .filter(m => m.level === 'OG-2')
      return { eg, og1, og2 }
    },
    roomPeriods: state => state.roomPeriods,
    roomIds: state => state.roomIds,
    roomListings: state => state.roomListings,
    lang: state => state.lang,
    translate: state => state.translate,
    pages: state => state.pages,
    posts: state => state.posts,
    firstpost: state => state.firstpost,
    postCategories: state => state.postCategories,
    aktuelles: state => state.aktuelles,
    pageNav: state => state.pageNav,
    dbIndex: state => state.dbIndex,
    contextTransactions: state => state.contextTransactions,
    plans: state => state.plans,
    rooms: state => state.rooms,
    periods: state => state.periods,
    sharedObjects: state => state.sharedObjects,
    sharedObject: state => state.sharedObject,
    sharedObjectLoader: state => state.sharedObjectLoader,
    metaSources: state => state.metaSources,
    archivbestandObjekts: state => state.archivbestandObjekts,
    displayFields: state => state.displayFields,
    genealogyPersons: state => state.genealogyPersons,
    errors: state => state.errors
  },
  mutations: {
    setLoader (state, payload) {
      state.loader = state.loader + payload
    },
    setLoaderText (state, payload) {
      state.loaderText = payload
    },
    setLang (state, payload) {
      state.lang = payload
    },
    setWpPages (state, payload) {
      // pages
      let pages = payload.sort(function (a, b) {
        return ((a.menu_position * 1) > (b.menu_position * 1)) ? 1 : (((b.menu_position * 1) > (a.menu_position * 1)) ? -1 : 0)
      })
      // pageNav
      // let nav = {'de': [], 'en': []}
      pages.forEach(page => {
        if (page.status === 'publish') {
          if (!page.sprache) {
            page.sprache = 'de'
          }
          state.pagesMultilang[page.sprache].push(page)
          if (page.hide_in_menu !== '1') {
            state.pageNavMultilang[page.sprache].push({
              menu_title: page.menu_title,
              slug: page.slug,
              lang: page.sprache,
              id: page.id,
              nav_css_classes: page.nav_css_classes,
              nav_init_open: page.nav_init_open,
              position: page.menu_position,
              parent: page.parent
            })
          }
        }
      })
      // state.pages = [{ id: 0, title: 'foo', slug: 'bar', content: 'buzz' }]
      state.pages = state.pagesMultilang[state.lang]
      state.pageNav = state.pageNavMultilang[state.lang]
    },
    setWpAktuelles (state, payload) {
      let posts = payload.sort(function (a, b) {
        let dateA = new Date(a.display_date).getTime()
        let dateB = new Date(b.display_date).getTime()
        return (dateA > dateB) ? 1 : (dateB > dateA) ? -1 : 0
      })
      posts = posts.filter(post => post.status === 'publish')
      state.aktuelles = posts
    },
    setPosts (state, payload) {
      let posts = payload.sort(function (a, b) {
        return ((a.post_order * 1) > (b.post_order * 1)) ? 1 : (((b.post_order * 1) > (a.post_order * 1)) ? -1 : 0)
      })
      state.posts = posts
    },
    setFirstPost (state, payload) {
      if (payload.length > 0) {
        payload.forEach(post => {
          if (post.post_language === 'en' && !state.firstpost.hasOwnProperty('en')) {
            state.firstpost.en = post
          }
          if (post.post_language !== 'en' && !state.firstpost.hasOwnProperty('de')) {
            state.firstpost.de = post
          }
        })
        // state.firstpost = payload[0]
      }
    },
    setPostCategories (state, payload) {
      // only set keys: id, count, name, slug
      state.postCategories = payload.map(cat => {
        return {
          id: cat.id,
          count: cat.count,
          name: cat.name,
          slug: cat.slug
        }
      })
    },
    switchPagesLang (state, lang) {
      state.pages = state.pagesMultilang[lang]
      state.pageNav = state.pageNavMultilang[lang]
    },
    setDbIndex (state, payload) {
      state.dbIndex = payload
    },
    setRoomListings (state, payload) {
      state.roomListings = payload
    },
    setAlbumPage (state, payload) {
      state.currAlbumPage = payload
    },
    addSharedObject (state, payload) {
      state.sharedObjects.push(payload)
    },
    setSharedObjectLoader (state, payload) {
      state.sharedObjectLoader = state.sharedObjectLoader + payload
    },
    setSharedObject (state, payload) {
      state.sharedObject = payload
    },
    setMetaSources (state, payload) {
      state.metaSources = payload
    },
    addMetaSource (state, payload) {
      state.metaSources[payload.id] = payload
    },
    setArchivbestandObjekts (state, payload) {
      state.archivbestandObjekts = payload
    },
    setGenealogyPersons (state, payload) {
      state.genealogyPersons = payload
    },
    addError (state, payload) {
      state.errors.push(payload)
    }
  },
  actions: {
    setAlbumPage ({commit}, person) {
      commit('setAlbumPage', person)
    },
    getRoomObjects (context) {
      if (Object.keys(context.state.roomListings).length === 0) {
        context.commit('setLoaderText', 'loader_text_mosse_palais')
        context.commit('setLoader', 1)
        // axios.get('https://www.mari-portal.de/omeka/custom/api/rooms')
        axios.get('https://www.mari-portal.de/omeka/staticapi/rooms.json')
        .then(response => {
          context.commit('setRoomListings', response.data)
        })
        .catch(error => console.log(error))
        .finally(() => {
          context.commit('setLoader', -1)
        })
      }
    },
    getWpPages (context) {
      axios.get('https://www.mari-portal.de/wp/wp-json/wp/v2/pages?per_page=100')
        .then((response) => {
          context.commit('setWpPages', response.data)
          // console.log(response.data)
        })
        .catch((e) => {
          context.commit('addError', e)
          // console.log('setWpPages error:', e)
        })
    },

    getWpAktuelles (context) {
      axios.get('https://www.mari-portal.de/wp/wp-json/wp/v2/aktuelles?per_page=100')
        .then((response) => {
          context.commit('setWpAktuelles', response.data)
        })
        .catch(() => {

        })
    },

    getPosts (context) {
      axios.get('https://www.mari-portal.de/wp/wp-json/wp/v2/posts?per_page=100')
        .then((response) => {
          context.commit('setPosts', response.data)
          context.commit('setFirstPost', response.data)
        })
        .catch(() => {

        })
    },

    getPostsByCategoryId (context, categoryId) {
      return new Promise((resolve, reject) => {
        axios.get('https://www.mari-portal.de/wp/wp-json/wp/v2/posts?per_page=100&categories=' + categoryId)
          .then((response) => {
            context.commit('setPosts', response.data)
            context.commit('setFirstPost', response.data)
            resolve(response.data)
          })
          .catch((e) => {
            context.commit('addError', e)
            reject(e)
          })
      })
    },

    getPostCategories (context) {
      axios.get('https://www.mari-portal.de/wp/wp-json/wp/v2/categories?per_page=100')
        .then((response) => {
          context.commit('setPostCategories', response.data)
        })
        .catch((e) => {
          context.commit('addError', e)
        })
    },
    getGenealogyPersons (context) {
      axios.get('https://www.mari-portal.de/wp/wp-json/wp/v2/genealogie?per_page=100')
        .then((response) => {
          context.commit('setGenealogyPersons', response.data)
        })
        .catch((e) => {
          context.commit('addError', e)
        })
    },

    getDbIndex (context) {
      return new Promise((resolve, reject) => {
        if (context.state.dbIndex.length === 0) {
          context.commit('setLoaderText', 'loader_text_db')
          context.commit('setLoader', 1)
          axios.get('https://www.mari-portal.de/omeka/custom/api/sharedobjectlist')
          .then(response => {
            context.commit('setDbIndex', response.data)
            resolve(response.data)
          })
          .catch(e => {
            context.commit('addError', e)
            reject(e)
          })
          .finally(() => {
            context.commit('setLoader', -1)
          })
        } else {
          resolve(context.state.dbIndex)
        }
      })
    },

    fetchSharedObject (context, id) {
      return new Promise((resolve, reject) => {
        let found = context.state.sharedObjects.find(obj => obj.id === id)
        if (!found) {
          const getDublinCore = true
          const sharedObject = {}
          sharedObject.hasImage = false
          sharedObject.imageCount = 0
          sharedObject.imageIds = []
          context.commit('setSharedObjectLoader', 1)
          axios.get('https://www.mari-portal.de/omeka/api/items/' + id)
          .then(response => {
            if (
              response.data.message &&
              response.data.message === 'Invalid record. Record not found.'
            ) {
              reject(response.data.message)
            } else {
              sharedObject.id = response.data.id
              sharedObject.meta = {}
              let cmsgId = null
              let acquisitionDate = null
              let contextTransactions = [...context.state.contextTransactions]
              response.data.element_texts.forEach(e => {
                if (e.element_set.name !== 'Dublin Core' || getDublinCore) {
                  sharedObject.meta[e.element.name.replace(/[-\s]/g, '_')] = e.text
                }
                if (e.element.name === 'Sigle konstituierende Nachricht ID') {
                  cmsgId = e.text * 1
                }
                if (e.element.name === 'Erwerbungsdatum (frühestens)') {
                  acquisitionDate = e.text
                }
                if (e.element.name === 'Kontextinformation: Erbgang Rudolf auf Emilie Mosse' && e.text === 'ignorieren') {
                  contextTransactions.forEach(ct => {
                    if (ct.Erwerber === 'Emilie Mosse') {
                      contextTransactions.splice(contextTransactions.indexOf(ct), 1)
                    }
                  })
                }
                if (e.element.name === 'Kontextinforation: Erbgang Emilie Mosse auf Felicia Lachmann-Mosse' && e.text === 'ignorieren') {
                  contextTransactions.forEach(ct => {
                    if (ct.Erwerber === 'Felicia Lachmann-Mosse') {
                      contextTransactions.splice(contextTransactions.indexOf(ct), 1)
                    }
                  })
                }
                if (e.element.name === 'Kontextinformation: Eigentumsübertragung an Treuhand GmbH' && e.text === 'ignorieren') {
                  contextTransactions.forEach(ct => {
                    if (ct.Erwerber === 'Rudolf Mosse Treuhand Verwaltungs GmbH') {
                      contextTransactions.splice(contextTransactions.indexOf(ct), 1)
                    }
                  })
                }
              })
              if (acquisitionDate) {
                contextTransactions = contextTransactions.filter(ct => {
                  return new Date(ct['Datum Transaktion (maschinell)']) >= new Date(acquisitionDate)
                })
              }
              sharedObject.cmsg_meta = {}
              sharedObject.linked_objects = []
              sharedObject.linked_objects_num_fields = {}
              sharedObject.sourceIds = []
              sharedObject.transactions = []
              const linkedObjectsNumFields = {}
              const transactions = []
              if (
                response.data.extended_resources &&
                response.data.extended_resources.linked_objects &&
                response.data.extended_resources.linked_objects.items.length > 0
              ) {
                let primaryImageId = null
                response.data.extended_resources.linked_objects.items.forEach(e => {
                  if (e.id === cmsgId) {
                    sharedObject.cmsg_meta.id = e.id
                    sharedObject.cmsg_meta.subject_item_type = e.subject_item_type.name
                    e.subject_element_texts.forEach(se => {
                      sharedObject.cmsg_meta[se.element.name.replace(/[-\s]/g, '_')] = se.text
                    })
                  }
                  let linkedObject = {}
                  let imgAllowed = false
                  linkedObject.id = e.id
                  linkedObject.subject_item_type = e.subject_item_type.name
                  // linkedObject.relation_text = e.relation_text
                  linkedObject.meta = {}
                  e.subject_element_texts.forEach(subjectElementText => {
                    if (
                      (subjectElementText.element.name !== 'Title' &&
                      subjectElementText.element.id !== 50) ||
                      getDublinCore
                    ) {
                      linkedObject.meta[subjectElementText.element.name] = subjectElementText.text
                      if (
                        subjectElementText.element.name === 'Sigle Quelle ID' &&
                        subjectElementText.text &&
                        !sharedObject.sourceIds.includes(subjectElementText.text)
                      ) {
                        sharedObject.sourceIds.push(subjectElementText.text)
                      }
                      if (
                        !linkedObjectsNumFields[subjectElementText.element.name] &&
                        context.state.displayFields.includes(subjectElementText.element.name)
                      ) {
                        linkedObjectsNumFields[subjectElementText.element.name] = [
                          {
                            'count': 1,
                            'text': subjectElementText.text
                          }
                        ]
                      } else if (context.state.displayFields.includes(subjectElementText.element.name)) {
                        let found = linkedObjectsNumFields[subjectElementText.element.name].find(f => f.text === subjectElementText.text)
                        if (found) {
                          found.count++
                        } else {
                          linkedObjectsNumFields[subjectElementText.element.name].push({
                            'count': 1,
                            'text': subjectElementText.text
                          })
                        }
                      }
                      if (
                        linkedObject.subject_item_type === 'Bilddokument' &&
                        subjectElementText.element.name === 'Primärabbildung' &&
                        subjectElementText.text === 'ja'
                      ) {
                        primaryImageId = e.id
                      }
                      if (
                        linkedObject.subject_item_type === 'Bilddokument' &&
                        subjectElementText.element.name === 'Rechtestatus Abbildung' &&
                        (subjectElementText.text === 'keine Einschränkung' || subjectElementText.text === 'Bildrechte eingeholt')
                      ) {
                        imgAllowed = true
                      }
                    }
                  })
                  if (
                    e.subject_item_type.name === 'Bilddokument' &&
                    e.subject_item_files && e.subject_item_files[0] &&
                    e.subject_item_files[0].hasOwnProperty('filename') &&
                    imgAllowed
                  ) {
                    linkedObject.meta.filename = e.subject_item_files[0].filename
                    sharedObject.hasImage = true
                    if (!sharedObject.imageIds.includes(e.id)) {
                      sharedObject.imageCount++
                      sharedObject.imageIds.push(e.id)
                    }
                  }
                  if (e.subject_item_type.name === 'Transaktion') {
                    transactions.push(linkedObject.meta)
                  }
                  sharedObject.linked_objects.push(linkedObject)
                })
                if (primaryImageId) {
                  let found = sharedObject.imageIds.find(id => id === primaryImageId)
                  if (found) {
                    sharedObject.imageIds.splice(sharedObject.imageIds.indexOf(found), 1)
                    sharedObject.imageIds.unshift(found)
                  }
                }
                context.state.displayFields.forEach(field => {
                  if (linkedObjectsNumFields.hasOwnProperty(field)) {
                    sharedObject.linked_objects_num_fields[field] = linkedObjectsNumFields[field]
                  }
                })
                let transactionsAll = []
                if (transactions.length > 0) {
                  transactionsAll = [...transactions, ...contextTransactions]
                  transactionsAll.sort((a, b) => {
                    let ca = null
                    let cb = null
                    if (a.hasOwnProperty('Datum Transaktion (maschinell)')) {
                      ca = a['Datum Transaktion (maschinell)']
                    } else if (a.hasOwnProperty('Spätestes Datum (maschinell)')) {
                      ca = a['Spätestes Datum (maschinell)']
                    } else if (a.hasOwnProperty('Frühestes Datum (maschinell)')) {
                      ca = a['Frühestes Datum (maschinell)']
                    }

                    if (b.hasOwnProperty('Datum Transaktion (maschinell)')) {
                      cb = b['Datum Transaktion (maschinell)']
                    } else if (b.hasOwnProperty('Spätestes Datum (maschinell)')) {
                      cb = b['Spätestes Datum (maschinell)']
                    } else if (b.hasOwnProperty('Frühestes Datum (maschinell)')) {
                      cb = b['Frühestes Datum (maschinell)']
                    }
                    b.datum = cb

                    if (ca < cb) {
                      return -1
                    } else if (ca > cb) {
                      return 1
                    }
                    return 0
                  })
                  // when we find our earliest non-context transaction:
                  // remove preceding transactions since they're of type "Kontext"
                  for (let i = 0; i < transactionsAll.length; i++) {
                    if (!transactionsAll[i].Kontext) {
                      transactionsAll.splice(0, i)
                      break
                    }
                  }
                }
                sharedObject.transactions = transactionsAll
              }
              context.commit('addSharedObject', sharedObject)
              context.commit('setSharedObject', sharedObject)
              if (sharedObject.sourceIds.length > 0) {
                context.dispatch('fetchMetaSources', sharedObject.sourceIds)
                .then(metaSources => resolve(sharedObject))
              } else {
                resolve(sharedObject)
              }
            }
          })
          .catch(e => {
            context.commit('addError', e)
            reject(e)
          })
          .finally(() => {
            context.commit('setSharedObjectLoader', -1)
          })
        } else {
          context.commit('setSharedObject', found)
          resolve(found)
        }
      })
    },
    fetchMetaSources (context, sourceIds) {
      return new Promise((resolve, reject) => {
        let sourceIdsString = ''
        sourceIds.forEach(id => {
          if (context.state.metaSources.hasOwnProperty(id)) {
            delete sourceIds[sourceIds.indexOf(id)]
          } else {
            sourceIdsString += (sourceIdsString.length > 0) ? ',' + id : id
          }
        })
        if (sourceIdsString.length > 0) {
          context.commit('setSharedObjectLoader', 1)
          axios.get('https://www.mari-portal.de/omeka/api/items?range=' + sourceIdsString)
          .then(response => {
            response.data.forEach(item => {
              let meta = {}
              item.element_texts.forEach(e => {
                meta[e.element.name] = e.text
              })
              context.commit('addMetaSource', {
                id: item.id,
                item_type: item.item_type.name,
                meta: meta
              })
            })
            resolve(context.state.metaSources)
          })
          .catch(e => {
            context.commit('addError', e)
            reject(e)
          })
          .finally(() => {
            context.commit('setSharedObjectLoader', -1)
          })
        } else {
          resolve(context.state.metaSources)
        }
      })
    },
    fetchArchivbestandObjekts (context) {
      return new Promise((resolve, reject) => {
        if (context.state.archivbestandObjekts.length === 0) {
          context.commit('setLoader', 1)
          axios.get('https://www.mari-portal.de/omeka/custom/api/itemlist/?item_type=36')
          .then(response => {
            response.data.sort((a, b) => {
              a['meta']['Institution'] = a['meta']['Institution'] || ''
              a['meta']['Archiv___Stadt'] = a['meta']['Archiv___Stadt'] || ''
              a['meta']['Archiv___Land'] = a['meta']['Archiv___Land'] || ''
              return a['meta']['Archiv___Land'].localeCompare(b['meta']['Archiv___Land']) || a['meta']['Archiv___Stadt'].localeCompare(b['meta']['Archiv___Stadt']) || a['meta']['Institution'].localeCompare(b['meta']['Institution'])
            })
            let grouped = response.data.reduce((r, a) => {
              r[a['meta']['Archiv___Land']] = r[a['meta']['Archiv___Land']] || {}
              r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']] = r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']] || {}
              r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']][a['meta']['Institution']] = r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']][a['meta']['Institution']] || []
              r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']][a['meta']['Institution']].push({
                id: a['id'],
                Sigle: a['meta']['Sigle'],
                Archiv___Akten: a['meta']['Archiv___Akten'],
                Archiv___Bestand: a['meta']['Archiv___Bestand']
              })
              return r
            }, Object.create(null))
            context.commit('setArchivbestandObjekts', {...grouped})
            resolve({...grouped})
          })
          .catch(e => {
            context.commit('addError', e)
            reject(e)
          })
          .finally(() => {
            context.commit('setLoader', -1)
          })
        } else {
          resolve(context.state.archivbestandObjekts)
        }
      })
    }
  }
})

// export default store



// WEBPACK FOOTER //
// ./src/store/store.js